var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9962 0.292631C12.8087 0.105141 12.5544 -0.000186031 12.2892 -0.000186054C12.024 -0.000186077 11.7697 0.105141 11.5822 0.292631L6.63218 5.24263L1.68218 0.29263C1.49266 0.1162 1.2421 0.0201611 0.983206 0.0247182C0.724314 0.0292753 0.477283 0.134074 0.29409 0.317065C0.110897 0.500056 0.00582469 0.746971 0.000980959 1.00586C-0.00386278 1.26474 0.0919004 1.51541 0.26812 1.70513L5.92437 7.36294C6.1119 7.55043 6.36622 7.65576 6.6314 7.65576C6.89658 7.65576 7.1509 7.55043 7.33843 7.36294L12.9962 1.70669C13.1837 1.51916 13.2891 1.26484 13.2891 0.999662C13.2891 0.734483 13.1837 0.480161 12.9962 0.292631Z",
    fill: "#DFD8D0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownArrow);
export default __webpack_public_path__ + "static/media/dropdown-arrow.727557de4dc55572e3145cfc5d52b967.svg";
export { ForwardRef as ReactComponent };